import types from '../types';

/**
 * @param {types.Product[]} items
 * @param {types.Pagination} pagination
 * @returns {boolean}
 */
const shouldShowPagination = (items, pagination) => {
    if (
        !items ||
        !Array.isArray(items) ||
        !items.length ||
        !pagination ||
        !pagination.currentPage ||
        !pagination.pagesCount ||
        !pagination.rowsCount ||
        !pagination.rowsOnPage
    ) {
        return false;
    }

    return true;
};

export default shouldShowPagination;
